import qs from 'qs';
import { AxiosRequestConfig } from 'axios';
import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IChecklistAfter } from './interfaces';

export const getChecklistAfterList = (data: IDynamicTableParams) => {
  return instance()
    .post<IChecklistAfter[]>('/checkList/after/list', data)
    .then((response) => response.data);
};

export const getChecklistAfterListAll = () => {
  return instance()
    .get<IChecklistAfter[]>('/checkList/after/listAllNotDeleted')
    .then((response) => response.data);
};

export const getChecklistAfterAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/checkList/after/availableColumns')
    .then((response) => response.data);
};

export const getChecklistAfterAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/checkList/after/availableGroupColumns')
    .then((response) => response.data);
};

export const loadChecklistAfter = (checkListAfterId: number) => {
  return instance()
    .get<IChecklistAfter>(`/checkList/after/load/${checkListAfterId}`)
    .then((response) => response.data);
};

export const createChecklistAfter = (checklistAfter: IChecklistAfter) => {
  return instance()
    .post<IChecklistAfter>(`/checkList/after/save`, checklistAfter)
    .then((response) => response.data);
};

export const updateChecklistAfter = (checklistAfter: IChecklistAfter) => {
  return instance()
    .post<IChecklistAfter>(`/checkList/after/${checklistAfter.checkListId}/update`, checklistAfter)
    .then((response) => response.data);
};

export const loadChecklistAfterPdf = (checkListId: number) => {
  return instance()
    .post<Blob>(`/checkList/after/load/${checkListId}/pdf`, {}, { responseType: 'blob' })
    .then((response) => response.data);
};

export const downloadExcelReport = (config: AxiosRequestConfig) => {
  return instance()
    .post('/checkList/after/downloadExcel', null, {
      ...config,
      responseType: 'blob',
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, arrayFormat: 'repeat' }),
    })
    .then((response) => response);
};

export const downloadExecutorExcelReport = (config: AxiosRequestConfig) => {
  return instance()
    .post('/checkList/after/downloadExecutorExcel', null, {
      ...config,
      responseType: 'blob',
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, arrayFormat: 'repeat' }),
    })
    .then((response) => response);
};
